module.exports = __webpack_public_path__ + "static/pawel-sm-27c6d02cfacfd37ed63a73281f9abaf8.jpg";